import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Clock, Users, ArrowRight, Zap, Dumbbell, Calendar } from 'lucide-react';
type ScheduleSlot = {
  day: string;
  time: string;
};
interface ProgramCardData {
  image: string;
  imageAlt: string;
  eyebrow: string;
  title: string;
  meta: string;
  body: string;
  schedule?: ScheduleSlot[];
  price?: string;
  priceNote?: string;
  primaryCta: {
    label: string;
    to: string;
  };
  secondaryCta?: {
    label: string;
    to: string;
  };
}
const PROGRAMS: ProgramCardData[] = [{
  image: 'https://images.unsplash.com/photo-1552674605-db6ffd4facb5?q=80&w=1600&auto=format&fit=crop',
  imageAlt: 'High school athlete sprinting on indoor turf',
  eyebrow: 'High School · Ages 14+',
  title: 'Advanced Performance',
  meta: '75-min sessions · Max 8 athletes',
  body: 'Built for high school athletes preparing for varsity competition and college recruiting. Heavy emphasis on max velocity, force production, and position-specific power. Periodized blocks track every athlete\u2019s sprint times, vertical, and strength PRs every four weeks.',
  schedule: [{
    day: 'Mon',
    time: '9:00 – 10:15 AM'
  }, {
    day: 'Wed',
    time: '9:00 – 10:15 AM'
  }, {
    day: 'Tue',
    time: '6:00 – 7:15 PM'
  }, {
    day: 'Thu',
    time: '6:00 – 7:15 PM'
  }, {
    day: 'Fri',
    time: '1:00 – 2:15 PM'
  }],
  price: 'From $325/mo',
  primaryCta: {
    label: 'Enroll Now',
    to: '/pricing'
  },
  secondaryCta: {
    label: 'See Pricing',
    to: '/pricing'
  }
}, {
  image: 'https://images.unsplash.com/photo-1517963879433-6ad2b056d712?q=80&w=1600&auto=format&fit=crop',
  imageAlt: 'Middle school athlete training with resistance',
  eyebrow: 'Middle School · Ages 11–13',
  title: 'Performance Prep',
  meta: '60-min sessions · Max 8 athletes',
  body: 'The bridge between youth fundamentals and varsity-level training. Athletes build real strength under load, develop change-of-direction mechanics, and own their sprint patterns. The goal: enter high school stronger, faster, and more resilient than their peers.',
  schedule: [{
    day: 'Mon',
    time: '10:30 – 11:30 AM'
  }, {
    day: 'Wed',
    time: '10:30 – 11:30 AM'
  }, {
    day: 'Tue',
    time: '5:00 – 6:00 PM'
  }, {
    day: 'Thu',
    time: '5:00 – 6:00 PM'
  }, {
    day: 'Fri',
    time: '2:30 – 3:30 PM'
  }],
  price: 'From $270/mo',
  primaryCta: {
    label: 'Enroll Now',
    to: '/pricing'
  },
  secondaryCta: {
    label: 'See Pricing',
    to: '/pricing'
  }
}, {
  image: 'https://images.unsplash.com/photo-1576678927484-cc907957088c?q=80&w=1600&auto=format&fit=crop',
  imageAlt: 'Young athlete practicing agility drills',
  eyebrow: 'Youth · Ages 8–10',
  title: 'Foundations',
  meta: '60-min sessions · Max 8 athletes',
  body: 'Movement fundamentals taught the right way. Athletes learn how to sprint, jump, land, brace, and squat with proper mechanics. We build coordination, body awareness, and confidence in a structured, age-appropriate environment.',
  schedule: [{
    day: 'Tue',
    time: '4:00 – 5:00 PM'
  }, {
    day: 'Thu',
    time: '4:00 – 5:00 PM'
  }],
  price: 'From $270/mo',
  primaryCta: {
    label: 'Enroll Now',
    to: '/pricing'
  },
  secondaryCta: {
    label: 'See Pricing',
    to: '/pricing'
  }
}, {
  image: 'https://images.unsplash.com/photo-1599058917212-d750089bc07e?q=80&w=1600&auto=format&fit=crop',
  imageAlt: 'Coach working one-on-one with an athlete',
  eyebrow: 'Any Age · Customized',
  title: 'Private 1-on-1 Training',
  meta: '60-min sessions · With Fernando',
  body: 'Fully custom programming with the Director of Performance. Built around your athlete\u2019s sport, position, season, and individual gaps identified through testing. Ideal for athletes in-season, returning from injury, or preparing for combine and showcase events.',
  price: 'From $150',
  priceNote: 'per session · rate varies by frequency',
  primaryCta: {
    label: 'Book a Session',
    to: '/book'
  }
}, {
  image: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=1600&auto=format&fit=crop',
  imageAlt: 'Coach reviewing notes with parent and athlete',
  eyebrow: 'Not Sure Which Program?',
  title: 'Free 15-Min Consultation',
  meta: 'Phone or in-person at INPOWERiQ',
  body: 'A short discovery call with Coach Fernando. Walk through your athlete\u2019s goals, sport demands, schedule, and current training. Leave with a clear recommendation \u2014 no pressure, no commitment.',
  primaryCta: {
    label: 'Book Free Consultation',
    to: '/book'
  }
}];
export function Programs() {
  return <div className="w-full" data-id="element-732">
      {/* 1. HERO BAND */}
      <section className="relative bg-reach-black overflow-hidden" data-id="element-733">
        <div className="absolute inset-0 pointer-events-none overflow-hidden" data-id="element-734">
          <div className="absolute top-1/4 -left-40 w-[50%] h-1.5 bg-reach-red transform -rotate-[6deg] opacity-50" data-id="element-735" />
          <div className="absolute top-[42%] -left-40 w-[35%] h-1.5 bg-reach-red transform -rotate-[6deg] opacity-30" data-id="element-736" />
          <div className="absolute top-[60%] -left-40 w-[25%] h-1.5 bg-reach-red transform -rotate-[6deg] opacity-20" data-id="element-737" />
        </div>
        <div className="max-w-container mx-auto px-4 md:px-8 h-[280px] md:h-[320px] flex flex-col items-center justify-center text-center relative z-10" data-id="element-738">
          <h1 className="font-bebas text-white text-6xl md:text-8xl tracking-wide leading-none mb-3" data-id="element-739">
            Programs
          </h1>
          <p className="font-inter text-white/85 text-base md:text-xl max-w-2xl" data-id="element-740">
            Five ways to train at Reach Performance.
          </p>
        </div>
      </section>

      {/* 2. METHODOLOGY */}
      <section className="bg-white py-20 md:py-28" data-id="element-741">
        <div className="max-w-container mx-auto px-4 md:px-8" data-id="element-742">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center" data-id="element-743">
            <div data-id="element-744">
              <p className="font-inter text-reach-red text-xs uppercase tracking-[0.3em] font-semibold mb-3" data-id="element-745">
                Methodology
              </p>
              <h2 className="font-bebas text-5xl md:text-6xl tracking-wide leading-none mb-6" data-id="element-746">
                How We Train
              </h2>
              <p className="font-inter text-reach-black text-lg leading-relaxed mb-5" data-id="element-747">
                Speed and strength work are scheduled by day, not at random.
                Every session has a purpose.
              </p>
              <p className="font-inter text-reach-black/80 text-base leading-relaxed" data-id="element-748">
                Each week follows a periodized split. Athletes train specific
                qualities on specific days so the body adapts predictably and
                progress shows up on the field, the court, and on the testing
                sheet.
              </p>
            </div>

            <PeriodizationGraphic data-id="element-749" />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-16" data-id="element-750">
            <SplitBlock Icon={Zap} title="Speed Focus" items={[{
            days: 'Mon / Tue',
            label: 'Acceleration'
          }, {
            days: 'Wed / Thu',
            label: 'Change of Direction'
          }, {
            days: 'Fri',
            label: 'Max Velocity'
          }]} data-id="element-751" />
            <SplitBlock Icon={Dumbbell} title="Strength Focus" items={[{
            days: 'Mon',
            label: 'Lower Body'
          }, {
            days: 'Wed',
            label: 'Upper Body'
          }, {
            days: 'Fri',
            label: 'Full Body'
          }, {
            days: 'Tue / Thu',
            label: 'Full Body'
          }]} data-id="element-752" />
          </div>
        </div>
      </section>

      {/* 3. PROGRAM CARDS */}
      <section className="bg-reach-gray py-20 md:py-28" data-id="element-753">
        <div className="max-w-container mx-auto px-4 md:px-8 space-y-12 md:space-y-16" data-id="element-754">
          {PROGRAMS.map((program, idx) => <ProgramDetailCard key={program.title} program={program} reverse={idx % 2 === 1} data-id="element-755" />)}
        </div>
      </section>

      {/* 4. FINAL CTA STRIP */}
      <section className="bg-reach-red py-16 md:py-20" data-id="element-756">
        <div className="max-w-container mx-auto px-4 md:px-8 text-center" data-id="element-757">
          <h2 className="font-bebas text-white text-5xl md:text-7xl tracking-wide mb-4" data-id="element-758">
            Ready to Start?
          </h2>
          <p className="font-inter text-white text-lg md:text-xl mb-10 max-w-2xl mx-auto" data-id="element-759">
            Reserve your spot for Summer 2026.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-stretch sm:items-center max-w-md sm:max-w-none mx-auto" data-id="element-760">
            <Link to="/pricing" className="inline-flex items-center justify-center bg-white text-reach-black font-inter font-semibold px-6 min-h-[44px] md:min-h-[48px] rounded transition-colors duration-200 hover:bg-reach-black hover:text-white uppercase tracking-wide text-sm md:text-base" data-id="element-761">
              Enroll Now
            </Link>
            <Link to="/book" className="btn-secondary-dark sm:w-auto" data-id="element-762">
              Book Free Consultation
            </Link>
          </div>
        </div>
      </section>
    </div>;
}
/* ---------- Subcomponents ---------- */
function ProgramDetailCard({
  program,
  reverse
}: {
  program: ProgramCardData;
  reverse: boolean;
}) {
  return <article className={`group grid grid-cols-1 lg:grid-cols-2 gap-0 bg-white rounded-[4px] overflow-hidden border border-black/10 border-b-4 hover:border-b-reach-red transition-colors duration-200 ease-out ${reverse ? 'lg:[&>div:first-child]:order-2' : ''}`} data-id="element-763">
      <div className="relative aspect-[4/3] lg:aspect-auto lg:min-h-[480px] overflow-hidden bg-reach-black" data-id="element-764">
        <img src={program.image} alt={program.imageAlt} className="absolute inset-0 w-full h-full object-cover grayscale contrast-125" data-id="element-765" />
        <div className="absolute inset-0 bg-gradient-to-br from-black/30 via-transparent to-black/50" data-id="element-766" />
        <div className="absolute inset-0 bg-reach-red mix-blend-multiply opacity-[0.08]" data-id="element-767" />
        <div className="absolute top-0 left-0 w-16 h-1.5 bg-reach-red" data-id="element-768" />
      </div>

      <div className="p-8 md:p-12 flex flex-col" data-id="element-769">
        <p className="font-inter text-reach-red text-xs uppercase tracking-[0.3em] font-semibold mb-4" data-id="element-770">
          {program.eyebrow}
        </p>
        <h2 className="font-bebas text-4xl md:text-5xl tracking-wide leading-none mb-4" data-id="element-771">
          {program.title}
        </h2>
        <div className="flex items-center gap-4 mb-6 text-sm font-inter text-reach-black/70" data-id="element-772">
          <span className="flex items-center gap-1.5" data-id="element-773">
            <Clock size={14} className="text-reach-red" data-id="element-774" />
            <span className="uppercase tracking-wider" data-id="element-775">
              {program.meta.split(' · ')[0]}
            </span>
          </span>
          <span className="text-reach-black/30" data-id="element-776">·</span>
          <span className="flex items-center gap-1.5" data-id="element-777">
            <Users size={14} className="text-reach-red" data-id="element-778" />
            <span className="uppercase tracking-wider" data-id="element-779">
              {program.meta.split(' · ')[1]}
            </span>
          </span>
        </div>

        <p className="font-inter text-reach-black text-base leading-relaxed mb-7" data-id="element-780">
          {program.body}
        </p>

        {program.schedule && <div className="mb-7" data-id="element-781">
            <p className="font-inter text-xs uppercase tracking-[0.25em] font-semibold text-reach-black/60 mb-3 flex items-center gap-2" data-id="element-782">
              <Calendar size={14} className="text-reach-red" data-id="element-783" />
              Weekly Schedule
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-2 border-t border-black/10 pt-3" data-id="element-784">
              {program.schedule.map(slot => <div key={`${slot.day}-${slot.time}`} className="flex justify-between items-baseline border-b border-black/5 py-1.5" data-id="element-785">
                  <span className="font-bebas text-lg tracking-wider" data-id="element-786">
                    {slot.day}
                  </span>
                  <span className="font-inter text-sm text-reach-black/80" data-id="element-787">
                    {slot.time}
                  </span>
                </div>)}
            </div>
          </div>}

        {program.price && <div className="mb-7" data-id="element-788">
            <p className="font-bebas text-3xl md:text-4xl tracking-wide text-reach-black" data-id="element-789">
              {program.price}
              {program.priceNote && <span className="font-inter text-sm text-reach-black/60 font-normal ml-2 tracking-normal normal-case" data-id="element-790">
                  {program.priceNote}
                </span>}
            </p>
          </div>}

        <div className="mt-auto flex flex-col sm:flex-row gap-3 sm:items-center" data-id="element-791">
          <Link to={program.primaryCta.to} className="btn-primary" data-id="element-792">
            {program.primaryCta.label}
            <ArrowRight size={16} className="ml-2" data-id="element-793" />
          </Link>
          {program.secondaryCta && <Link to={program.secondaryCta.to} className="btn-secondary" data-id="element-794">
              {program.secondaryCta.label}
            </Link>}
        </div>
      </div>
    </article>;
}
function PeriodizationGraphic() {
  const days = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'];
  const speedRow: (0 | 1 | 2)[] = [1, 1, 2, 2, 1];
  const strengthRow: (0 | 1 | 2)[] = [1, 2, 1, 2, 1];
  return <div className="bg-reach-black text-white p-6 md:p-8 rounded relative overflow-hidden" data-id="element-795">
      <div className="absolute -right-10 top-4 w-32 h-1 bg-reach-red opacity-40 rotate-[8deg]" data-id="element-796" />
      <div className="absolute -right-10 top-8 w-24 h-1 bg-reach-red opacity-20 rotate-[8deg]" data-id="element-797" />

      <p className="font-inter text-reach-red text-xs uppercase tracking-[0.3em] font-semibold mb-1" data-id="element-798">
        Weekly Periodization
      </p>
      <p className="font-bebas text-2xl tracking-wide mb-6" data-id="element-799">
        Every Day Has A Purpose
      </p>

      <div className="grid grid-cols-[80px_repeat(5,1fr)] gap-2 items-center" data-id="element-800">
        <div data-id="element-801" />
        {days.map(d => <div key={d} className="font-bebas text-sm tracking-wider text-center text-white/70" data-id="element-802">
            {d}
          </div>)}

        <div className="font-inter text-xs uppercase tracking-widest text-white/70 flex items-center gap-1.5" data-id="element-803">
          <Zap size={12} className="text-reach-red" data-id="element-804" />
          Speed
        </div>
        {speedRow.map((v, i) => <Cell key={`s-${i}`} intensity={v} accent="red" data-id="element-805" />)}

        <div className="font-inter text-xs uppercase tracking-widest text-white/70 flex items-center gap-1.5" data-id="element-806">
          <Dumbbell size={12} className="text-reach-red" data-id="element-807" />
          Strength
        </div>
        {strengthRow.map((v, i) => <Cell key={`st-${i}`} intensity={v} accent="white" data-id="element-808" />)}
      </div>

      <div className="flex items-center gap-5 mt-6 text-xs font-inter text-white/60 uppercase tracking-wider" data-id="element-809">
        <span className="flex items-center gap-1.5" data-id="element-810">
          <span className="w-3 h-3 bg-reach-red rounded-sm" data-id="element-811" /> Primary
        </span>
        <span className="flex items-center gap-1.5" data-id="element-812">
          <span className="w-3 h-3 bg-white/20 rounded-sm" data-id="element-813" /> Secondary
        </span>
      </div>
    </div>;
}
function Cell({
  intensity,
  accent
}: {
  intensity: 0 | 1 | 2;
  accent: 'red' | 'white';
}) {
  if (intensity === 0) {
    return <div className="h-10 rounded-sm bg-white/[0.04]" data-id="element-814" />;
  }
  if (intensity === 1) {
    return <div className={`h-10 rounded-sm ${accent === 'red' ? 'bg-reach-red' : 'bg-white'}`} data-id="element-815" />;
  }
  return <div className="h-10 rounded-sm bg-white/20" data-id="element-816" />;
}
function SplitBlock({
  Icon,
  title,
  items
}: {
  Icon: ComponentType<{
    size?: number;
    className?: string;
  }>;
  title: string;
  items: {
    days: string;
    label: string;
  }[];
}) {
  return <div className="bg-white rounded p-6 md:p-8 border-l-4 border-reach-red" data-id="element-817">
      <div className="flex items-center gap-3 mb-5" data-id="element-818">
        <Icon size={22} className="text-reach-red" data-id="element-819" />
        <h3 className="font-bebas text-2xl md:text-3xl tracking-wide uppercase leading-none" data-id="element-820">
          {title}
        </h3>
      </div>
      <ul className="divide-y divide-black/10" data-id="element-821">
        {items.map(item => <li key={`${item.days}-${item.label}`} className="flex justify-between items-baseline py-2.5" data-id="element-822">
            <span className="font-bebas text-lg tracking-wider text-reach-black" data-id="element-823">
              {item.days}
            </span>
            <span className="font-inter text-sm md:text-base text-reach-black/80 uppercase tracking-wide" data-id="element-824">
              {item.label}
            </span>
          </li>)}
      </ul>
    </div>;
}